import { ContentSummaryModel } from '@/domain/models/content/user-content-summary-model'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'

export const computeContentValueId = (content: unknown) => {
  const model = content as ContentSummaryModel
  if (FeatureFlag.Key.NAV_PDV_WITH_PRODUCT_ID.checkEnabled()) {
    return model.productId
  }
  return model.id
}
